import "./module/userAgentChecker"
import "./module/plugin"
import "./module/swiper"

import MicroModal from 'micromodal';
MicroModal.init({
    disableScroll: true,
    awaitCloseAnimation: true,
});
